import { render, staticRenderFns } from "./StarBlock.vue?vue&type=template&id=3ea8baae&scoped=true"
import script from "./StarBlock.vue?vue&type=script&lang=js"
export * from "./StarBlock.vue?vue&type=script&lang=js"
import style0 from "./StarBlock.vue?vue&type=style&index=0&id=3ea8baae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea8baae",
  null
  
)

export default component.exports